import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'LocalGluons/index';
import { t } from 'Locale';
import Theme from 'Theme';
import { userIconStyle, loginButtonStyle } from '../../Menu.styles';

const LoginButton = ({ isUserLoggedIn, onPress, isPressed }) =>
    isUserLoggedIn ? (
        <Icon
            testID="account_button"
            name="logged_in"
            style={userIconStyle}
            tintColor={isPressed && Theme.secondaryButtonBorderColor}
            onPress={onPress}
        />
    ) : (
        <Button
            testID="menu_login_button"
            title={t('COMMON.LOGIN')}
            onPress={onPress}
            style={loginButtonStyle}
        />
    );

LoginButton.propTypes = {
    isUserLoggedIn: PropTypes.bool.isRequired,
    onPress: PropTypes.func.isRequired,
    isPressed: PropTypes.bool.isRequired
};
export default LoginButton;
